/* Partify paint estimator: one shared calculator for the landing page and modal. */
(function () {
  "use strict";

  var booted = false;
  var modal;
  var dialog;
  var state = {
    bodyType: "sedan",
    parts: new Set(["front-door"]),
    damage: "scratch",
    setup: "diy",
    contextFormat: "",
    recommendation: null
  };

  var FORMAT_CONTEXTS = {
    bottle: { parts: ["front-door"], damage: "scratch", setup: "diy" },
    pen: { parts: ["front-door"], damage: "chip", setup: "diy" },
    aerosol: { parts: ["hood"], damage: "deep", setup: "diy" },
    professional: { parts: ["front-door"], damage: "scratch", setup: "professional" }
  };
  var CONFIGURATOR_CONTEXTS = {
    bottle: {
      root: "[data-tubp-configurator]",
      focus: "[data-tubp-method][aria-checked=\"true\"]:not([disabled]), [data-tubp-method]:not([disabled]), [data-tubp-vin], [data-tubp-color]:not([disabled])"
    },
    pen: {
      root: "[data-tupp-configurator]",
      focus: "[data-tupp-method][aria-checked=\"true\"]:not([disabled]), [data-tupp-method]:not([disabled]), [data-tupp-vin], [data-tupp-color]:not([disabled])"
    },
    aerosol: {
      root: "[data-tuap-configurator]",
      focus: "[data-tuap-method][aria-checked=\"true\"]:not([disabled]), [data-tuap-method]:not([disabled]), [data-tuap-vin], [data-tuap-color]:not([disabled])"
    },
    professional: {
      root: "[data-prof-configurator]",
      focus: "[data-prof-method][aria-checked=\"true\"]:not([disabled]), [data-prof-method]:not([disabled]), [data-prof-vin], [data-prof-color]:not([disabled])"
    }
  };

  var PARTS = {
    "front-bumper": { label: "Front bumper", area: 1.8, fullPanelOunces: 15 },
    hood: { label: "Hood", area: 2.8 },
    "front-fender": { label: "Front fender", area: 1.1, fullPanelOunces: 8 },
    "front-door": { label: "Front door", area: 1.45 },
    "rear-door": { label: "Rear door", area: 1.35 },
    "rear-quarter": { label: "Rear quarter", area: 1.45 },
    trunk: { label: "Trunk / hatch / tailgate", area: 1.7, fullPanelOunces: 20 },
    "rear-bumper": { label: "Rear bumper", area: 1.8, fullPanelOunces: 15 },
    roof: { label: "Roof", area: 3.5 }
  };
  var DAMAGE = {
    scratch: { factor: 0.38 / 1.45 },
    deep: { factor: 0.78 / 1.45 },
    panel: { factor: 1 }
  };

  function $(selector, root) { return (root || document).querySelector(selector); }
  function $all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function boards() { return $all("[data-pae-board]"); }
  function normalize(value) { return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, ""); }
  function amount(value) { return (Math.round(value * 100) / 100).toString().replace(/\.0+$/, "") + " oz"; }
  function roundQuarter(value) { return Math.max(0.25, Math.ceil(value * 4) / 4); }
  function selectedParts() { return Array.from(state.parts).map(function (id) { return PARTS[id]; }).filter(Boolean); }
  function fullPanelOunces(part) {
    return part.fullPanelOunces || (part.area * 1.45 * 1.22);
  }

  function chipAmount(panelCount) {
    /* A chip is a localized defect. More selected panels mean more chip locations,
       not a full-panel paint calculation. */
    if (panelCount <= 1) return 0.1;
    if (panelCount <= 3) return 0.2;
    if (panelCount <= 6) return 0.35;
    return 0.5;
  }
  function calculate() {
    var parts = selectedParts();
    var totalFullPanelOunces = parts.reduce(function (total, part) { return total + fullPanelOunces(part); }, 0);
    var needed = state.damage === "chip"
      ? chipAmount(parts.length)
      : roundQuarter(totalFullPanelOunces * DAMAGE[state.damage].factor);
    var format;
    var buy;
    var quantity = 1;
    var copy;

    if (state.damage === "chip") {
      format = "Pen";
      buy = 0.5;
      copy = "A paint pen is the lowest-waste choice for a localized chip, even when more than one chip is selected.";
    } else if (state.setup === "professional") {
      if (needed <= 8) { format = "Half Pint"; buy = 8; copy = "A half pint gives a spray setup the application allowance needed for this repair."; }
      else if (needed <= 16) { format = "Pint"; buy = 16; copy = "A pint is the sensible professional volume for this repair scope."; }
      else if (needed <= 32) { format = "Quart"; buy = 32; copy = "A quart gives enough material to cover and blend the selected work."; }
      else { format = "Gallon"; buy = 128; copy = "This job calls for shop-scale volume. Confirm your spray plan before ordering."; }
    } else if (needed <= 0.5) {
      format = "Pen"; buy = 0.5; copy = "A paint pen is the lowest-waste choice for pinpoint chips and very fine scratches.";
    } else if (needed <= 1.5) {
      format = "Bottle"; buy = 1; copy = "A one-ounce bottle is the right starting point for a controlled touch-up repair.";
    } else if (needed <= 5) {
      format = "Aerosol"; buy = 12; copy = "An aerosol gives broader, more even coverage for this repair.";
    } else {
      format = "Aerosol";
      buy = 12;
      quantity = Math.ceil(needed / buy);
      copy = quantity > 1
        ? "Use multiple aerosols for this repair, or choose professional spray if you have a spray gun."
        : "An aerosol gives broader, more even coverage for this repair.";
    }

    state.recommendation = {
      format: format,
      buy: buy,
      needed: needed,
      quantity: quantity,
      copy: copy,
      areas: parts.map(function (part) { return part.label; }).join(", ")
    };
    return state.recommendation;
  }

  function updatePartControls() {
    var labels = selectedParts().map(function (part) { return part.label; });
    boards().forEach(function (board) {
      $all("[data-pae-part]", board).forEach(function (control) {
        control.setAttribute("aria-pressed", String(state.parts.has(control.getAttribute("data-pae-part"))));
      });
      $all("[data-pae-panel]", board).forEach(function (panel) {
        panel.classList.toggle("is-selected", state.parts.has(panel.getAttribute("data-pae-panel")));
      });
      var note = $("[data-pae-selection-note]", board);
      if (note) note.textContent = labels.length + " area" + (labels.length === 1 ? "" : "s") + " selected: " + labels.join(", ");
    });
  }
  function updateBodyType() {
    boards().forEach(function (board) {
      $all("[data-pae-body-type]", board).forEach(function (button) {
        button.classList.toggle("is-selected", button.getAttribute("data-pae-body-type") === state.bodyType);
      });
      var car = $("[data-pae-car]", board);
      if (car) car.setAttribute("data-pae-body", state.bodyType);
    });
  }
  function updateDamage() {
    boards().forEach(function (board) {
      $all("[data-pae-damage]", board).forEach(function (button) {
        var selected = button.getAttribute("data-pae-damage") === state.damage;
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-checked", String(selected));
      });
    });
  }
  function updateSetup() {
    boards().forEach(function (board) {
      $all("[data-pae-setup]", board).forEach(function (button) {
        var selected = button.getAttribute("data-pae-setup") === state.setup;
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-checked", String(selected));
      });
    });
  }
  function updateResult() {
    var rec = calculate();
    boards().forEach(function (board) {
      var format = $("[data-pae-result-format]", board);
      var copy = $("[data-pae-result-copy]", board);
      var needed = $("[data-pae-result-needed]", board);
      var buy = $("[data-pae-result-buy]", board);
      var primer = $("[data-pae-primer]", board);
      var clear = $("[data-pae-clear]", board);
      var cartMessage = $("[data-pae-cart-message]", board);
      var cta = $("[data-pae-continue]", board);
      if (format) format.textContent = rec.quantity > 1 ? rec.quantity + " x " + rec.format : rec.format;
      if (copy) copy.textContent = rec.copy;
      if (needed) needed.textContent = amount(rec.needed);
      if (buy) buy.textContent = (rec.quantity > 1 ? rec.quantity + " x " : "") + amount(rec.buy);
      if (primer) primer.textContent = state.damage === "deep" || state.damage === "panel" ? "Recommended" : "If bare metal is exposed";
      if (clear) clear.textContent = "Recommended for gloss repairs";
      if (cartMessage) cartMessage.textContent = "Continue to the product configurator to confirm your exact color and package before adding to cart.";
      if (cta) cta.innerHTML = "Continue with this recommendation <span aria-hidden=\"true\">&rarr;</span>";
    });
  }
  function updateAll() {
    updateBodyType(); updatePartControls(); updateDamage(); updateSetup(); updateResult();
  }
  function formatFromTrigger(trigger) {
    if (!trigger) return "";
    var explicit = normalize(trigger.getAttribute("data-pae-format"));
    if (FORMAT_CONTEXTS[explicit]) return explicit;
    if (trigger.closest("[data-tubp-configurator]")) return "bottle";
    if (trigger.closest("[data-tupp-configurator]")) return "pen";
    if (trigger.closest("[data-tuap-configurator]")) return "aerosol";
    if (trigger.closest("[data-prof-configurator]")) return "professional";
    return "";
  }
  function applyFormatContext(format) {
    var context = FORMAT_CONTEXTS[format];
    if (!context || state.contextFormat === format) return;
    state.contextFormat = format;
    state.parts = new Set(context.parts);
    state.damage = context.damage;
    state.setup = context.setup;
  }
  function openModal(trigger) {
    if (!modal) return;
    applyFormatContext(formatFromTrigger(trigger));
    modal.hidden = false;
    document.documentElement.classList.add("pae-modal-open");
    document.body.classList.add("pae-modal-open");
    updateAll();
    setTimeout(function () { if (dialog) dialog.focus(); }, 0);
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove("pae-modal-open");
    document.body.classList.remove("pae-modal-open");
  }
  function currentConfiguratorContext() {
    if (CONFIGURATOR_CONTEXTS[state.contextFormat]) return CONFIGURATOR_CONTEXTS[state.contextFormat];
    return Object.keys(CONFIGURATOR_CONTEXTS).map(function (key) {
      return CONFIGURATOR_CONTEXTS[key];
    }).find(function (context) {
      return $(context.root);
    }) || null;
  }
  function openExactColorFlow() {
    var context = currentConfiguratorContext();
    var root = context ? $(context.root) : null;
    if (!root) {
      var finder = $("[data-tuf-open]");
      closeModal();
      if (finder) { finder.click(); return; }
      openGarage();
      return;
    }
    closeModal();
    root.setAttribute("data-pae-color-handoff", "");
    root.scrollIntoView({ behavior: "smooth", block: "start" });
    window.setTimeout(function () {
      var focusTarget = $(context.focus, root);
      if (focusTarget && typeof focusTarget.focus === "function") focusTarget.focus({ preventScroll: true });
    }, 350);
    window.setTimeout(function () {
      root.removeAttribute("data-pae-color-handoff");
    }, 1800);
  }
  function openGarage() {
    window.setTimeout(function () {
      if (window.GarageV2 && typeof window.GarageV2.open === "function") window.GarageV2.open();
      else if (typeof window.toggleGaragePopup === "function") window.toggleGaragePopup();
    }, 50);
  }
  function bind() {
    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest ? event.target.closest("[data-pae-open], [data-pae-close], [data-pae-continue], [data-pae-body-type], [data-pae-part], [data-pae-damage], [data-pae-setup]") : null;
      if (!target) return;
      if (target.hasAttribute("data-pae-open")) { event.preventDefault(); openModal(target); return; }
      if (target.hasAttribute("data-pae-close")) { closeModal(); return; }
      if (!target.closest("[data-pae-board]")) return;
      if (target.hasAttribute("data-pae-continue")) { openExactColorFlow(); return; }
      if (target.hasAttribute("data-pae-body-type")) { state.bodyType = target.getAttribute("data-pae-body-type"); updateBodyType(); return; }
      if (target.hasAttribute("data-pae-part")) {
        var part = target.getAttribute("data-pae-part");
        if (!PARTS[part]) return;
        if (state.parts.has(part) && state.parts.size > 1) state.parts.delete(part);
        else state.parts.add(part);
        updatePartControls(); updateResult(); return;
      }
      if (target.hasAttribute("data-pae-damage")) { state.damage = target.getAttribute("data-pae-damage"); updateDamage(); updateResult(); return; }
      if (target.hasAttribute("data-pae-setup")) { state.setup = target.getAttribute("data-pae-setup"); updateSetup(); updateResult(); }
    });
    window.addEventListener("partify:vehicle:changed", updateAll);
    window.addEventListener("searchTermsUpdated", updateAll);
  }
  function boot() {
    if (booted) return;
    modal = $("[data-pae-modal]");
    if (!modal && !$("[data-pae-board]")) return;
    booted = true;
    /* PDP estimator markup is rendered inside the format-specific product shell.
       Portal the fixed dialog to body so broad Pen/Aerosol/Professional button
       rules cannot reset or hide the calculator controls. */
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    dialog = modal ? $(".pae-modal__dialog", modal) : null;
    bind();
    updateAll();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
